// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f1c94e0","453":"7912531b","732":"87555813","977":"a268bfd6"}[chunkId] + ".chunk.js";
};